import { Box } from '@breathelife/mui';
import { ReactElement } from 'react';

import { Icon, ReactHtmlParser, Text } from '@breathelife/ui-components';
import { FieldTypes, IconNames } from '@zinnia/form-engine-sdk';

import { Bold, CheckboxGroupWrap, CheckboxWrap } from './Styles';

type CheckboxData = { title?: string; label: string; checked: boolean };

type CheckboxGroupProps = {
  checkboxes: CheckboxData[];
  fallbackValue?: string;
  fieldType: FieldTypes;
};

export function CheckboxGroup(props: CheckboxGroupProps): ReactElement {
  const { checkboxes, fallbackValue, fieldType } = props;
  const hasValidOptions = checkboxes.length > 0;

  const isCheckboxGroup = fieldType === FieldTypes.checkboxGroup;
  const checkedFields = isCheckboxGroup ? checkboxes : checkboxes.filter((checkbox) => checkbox.checked === true);

  return (
    <CheckboxGroupWrap>
      {hasValidOptions
        ? checkedFields.map((checkbox: CheckboxData, index: number) => (
            <Checkbox key={`${checkbox.label}-${index}`} checkbox={checkbox} displayCheckbox={isCheckboxGroup} />
          ))
        : fallbackValue}
    </CheckboxGroupWrap>
  );
}

function Checkbox(props: { checkbox: CheckboxData; displayCheckbox: boolean }): ReactElement {
  const { checkbox, displayCheckbox } = props;

  return (
    <CheckboxWrap display='flex' mb={1.5}>
      {displayCheckbox && (
        <Box pr={1.5} pt={0.5}>
          <Icon name={checkbox.checked ? IconNames.checkmark : IconNames.close} size='12px' />
        </Box>
      )}
      <Text variant='copy'>
        {checkbox.title && (
          <Bold>
            <ReactHtmlParser html={checkbox.title} />:
          </Bold>
        )}{' '}
        <ReactHtmlParser html={checkbox.label} />
      </Text>
    </CheckboxWrap>
  );
}
